<template>
  <div>
    <p class="default-text text-lg lg:text-xl max-w-3xl">
      Falls Sie Fragen oder Interesse an einem Bilder haben sollten schreiben
      Sie mir gerne per email an:
      <a class="email-highlight" href="mailto:schlesselmann.g@web.de"
        >schlesselmann.g@web.de</a
      >
    </p>

    <!--
    Previous contact form kept for later reuse.
    <h1 class="default-text text-3xl lg:text-4xl mb-2 tracking-wide">Kontakt</h1>
    <p class="grey-text mb-8 max-w-xl">
      Schreiben Sie uns eine Nachricht. Pflichtfelder sind mit einem Stern markiert.
    </p>
    <form class="max-w-xl" @submit.prevent="onSubmit">
      ...
    </form>
    -->
  </div>
</template>

<script>
/*
export default {
  name: "Contact",
  data() {
    return {
      name: "",
      email: "",
      message: "",
      honeypot: "",
      submitting: false,
      status: "idle",
      errorMessage: "",
    };
  },
  methods: {
    async onSubmit() {
      if (this.honeypot) {
        this.status = "success";
        return;
      }

      const endpoint = process.env.VUE_APP_CONTACT_FORM_URL;
      if (!endpoint) {
        this.status = "error";
        this.errorMessage =
          "Das Kontaktformular ist noch nicht konfiguriert. Bitte setzen Sie die Umgebungsvariable VUE_APP_CONTACT_FORM_URL beim Build.";
        return;
      }

      this.submitting = true;
      this.status = "idle";
      this.errorMessage = "";

      const payload = {
        name: this.name,
        email: this.email,
        message: this.message,
      };

      try {
        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (!res.ok) {
          const text = await res.text();
          throw new Error(text || `HTTP ${res.status}`);
        }

        this.status = "success";
        this.name = "";
        this.email = "";
        this.message = "";
      } catch (e) {
        this.status = "error";
        this.errorMessage =
          "Senden ist fehlgeschlagen. Bitte versuchen Sie es spaeter erneut oder kontaktieren Sie uns per E-Mail.";
      } finally {
        this.submitting = false;
      }
    },
  },
};
*/
</script>

<style scoped>
.email-highlight {
  color: #000000;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

/*
.contact-input::placeholder {
  color: #00000040;
}
*/
</style>
